import React, { useCallback, useEffect, useState } from 'react'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

import ECRenewalForm from '@/Form/ECRenewalForm'
import FormStatus    from '@/Form/FormStatus'

import ECRenewalBudgetChange from '@/Billing/ECRenewalBudgetChange'

import Message from '@Pure/Message'
import Loader  from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

import { isTrue } from '@root/utility'

export default PageWrapper(function ECRenewalPage (props)
{
	const [status, setStatus] = useState({ });
	const [infos, setInfos] = useState();
	const [active_accounts, setActiveAccounts] = useState();
	const [EC, setEC] = useState();
	const [EC_admins, setECAdmins] = useState();
	const [loading, setLoading] = useState();
	const [fetch_id, setFetchId] = useState(0);

	useEffect(function ()
	{
		setLoading(true);
		setStatus({ });

		(async function ()
		{
			try
			{
				var response = await request('/EC-renewal/form-infos')
				.config({ keyword: 'ressource' })
				.post({ });
			}
			catch (update)
			{
				setLoading(false);
				return setStatus(update);
			}

			setActiveAccounts(response.active_accounts);
			setInfos(response.renewal_infos || null);
			setEC(response.EC);
			setECAdmins(response.EC_admins || []);
			setLoading(false);
		})();
	},
	[fetch_id]);

	const handleSuccess = useCallback(function (response)
	{
		setFetchId(id => id + 1);
	},
	[]);

	const handleBudgetChange = useCallback(function (value)
	{
		setEC(function (EC)
		{
			return { ...EC, budget_range: value || 'none' };
		});
	},
	[]);

	const budget = infos
	? infos.budget_range || 'none'
	: EC?.budget_range || 'none';

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	const EC_admins_list = (EC_admins || []).map(function (user)
	{
		return (
			<div className="c-dashboard__row" key={ user.id }>

				<div className="c-dashboard__cell">
					{ user.lastname }
					{ ' ' }
					{ user.firstname }
				</div>

				<div className="c-dashboard__cell">
					{ user.email }
				</div>

			</div>
		);
	});

	const admins_table = EC ?
	(
		<div className={ bemit('c-dashboard',
			['consended', 'EC-renewal-admins']) }>

			<div className="c-dashboard__row is-header-row">

				<div className="c-dashboard__cell">
					Nom prénom
				</div>

				<div className="c-dashboard__cell">
					E-mail
				</div>

			</div>

			{ EC_admins_list }
		</div>
	)
	: undefined;

	const budget_table = budget !== 'none' ?
	(
		<div className={ bemit('c-dashboard', ['EC-renewal']) }>

			<div className="c-dashboard__row">

				{ loader }

				<div className="c-dashboard__cell EC-renewal__budget-title">
					Votre budget de fonctionnement (0.2% de la masse salariale brute)
				</div>

				<ECRenewalBudgetChange default-budget={ budget }
					onChange={ handleBudgetChange }
				/>

				<div className="c-dashboard__cell EC-renewal__more-infos">
					<a href="/documents/2026_Grille_cotisations_CSE.pdf" target="_blank" className="u-full-width u-padding-top-10 u-padding-bottom-10 u-padding-left-15 u-padding-right-15">
						Grille des cotisations
					</a>
				</div>

			</div>

		</div>
	)
	: undefined;

	const page = EC && isTrue(EC.renewal_disabled) ?
	(
		<div className="page-content c-EC-renewal">

			<FormStatus
				error="Votre structure n'a pas renouvelé son contrat Synergies."
			/>

		</div>
	)
	:
	(
		<div className="page-content c-EC-renewal">

			{ infos ? undefined : budget_table }

			{
				EC && !infos ?
				(
					<ECRenewalForm EC={ EC } infos={ infos }
						active_accounts={ active_accounts }
						admins_table={ admins_table }
						onSuccess={ handleSuccess }
					/>
				)
				: infos ?
				(
					<div className="o-container">
						<Message color="green" icon="checked">
							Merci pour votre mise à jour. Un e-mail de confirmation a été envoyé aux élus de la plateforme (liste ci-dessous).
						</Message>

						{ admins_table }
					</div>
				)
				: undefined
			}

			<FormStatus { ...status } />

		</div>
	);

	return (
		<Layout page_title="Mise à jour CSE" { ...props }>

			{ page }

		</Layout>
	);
});